import { IconButton, TableCell, TableHead, TableRow } from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";
import Tooltip from "@material-ui/core/Tooltip";
import MaterialTable from "material-table";
import React, { useState, useRef, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import ModalConfirmAction from "../ModalConfirmAction/ModalConfirmAction";
import ViewControlMenu from "../ViewControlMenu/ViewControlMenu";
import {
  Convention,
  GeneralStyle,
  useStyles,
  TableActions,
  RightSection,
  ContentDownloadFile,
  TextDownloadFile,
  ContentFilters,
} from "./AdminPrivateGuestsComponent.styled";
import { purple } from "@mui/material/colors";
import Checkbox from "@mui/material/Checkbox";
import ExportExcelFile from "../ReportSurveyBlock/ExportExcelFile/ExportExcelFile";
import { DeleteTwoTone } from "@material-ui/icons";
import { theme as themeConfig } from "../../themes/themes";
import ReactCountryFlag from "react-country-flag";
import GeneralFiltersContainer from "../../containers/GeneralFiltersContainer/GeneralFiltersContainer";
import SearchComponent from "../SearchComponent/SearchComponent";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import PersonIcon from "@mui/icons-material/Person";
import CoachEventThemeUpdate from "../CoachEventThemeUpdate/CoachEventThemeUpdate";

const label = { inputProps: { "aria-label": "Checkbox attendance" } };

const AdminPrivateGuestsComponent = ({
  data,
  event,
  fromPage,
  eventDate,
  nameEvent,
  handleChangePage,
  handleChangeRowsPerPage,
  hadleDeleteParticipant,
  rowsPerPageOptions,
  rowsPerPage,
  page,
  allPages,
  handleCheckAttendance,
  dataDownloadAttendees,
  handleDownloadAttendees,
  FilterEvents,
  setDataFilter,
  filtered,
  setFiltered,
  handleCheckAllAttendance,
  allAttendend,
  allThemes,
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorSelected, setAnchorSelected] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(null);
  const [showCards, setShowCards] = useState(false);
  const [searchText, setSearchText] = useState();
  const rSearch = useRef();

  const getDataBySearch = () => {
    setSearchText(rSearch?.current?.value);
  };

  const applySearchOnBreak = () => {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(() => {
        getDataBySearch();
      }, 500);
    };
  };

  const handleSearch = applySearchOnBreak();

  useEffect(() => {
    FilterEvents(searchText);
  }, [searchText]);

  let handleClickActions = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setAnchorSelected(rowData.id);
  };

  let handleCloseActions = () => {
    setAnchorEl(null);
    setAnchorSelected(null);
  };

  let deleteSurvey = (rowData) => {
    hadleDeleteParticipant(rowData);
    setOpenDeleteModal(null);
  };

  const showDeleteModal = () => {
    return openDeleteModal ? (
      <ModalConfirmAction
        title={"Are you sure you want to delete the guest?"}
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        fn={deleteSurvey}
      />
    ) : null;
  };

  const filtersViews = {
    countries: true,
    cities: true,
    search: {
      show: false,
      label: "Name - Last Name - Email",
    },
    status: true,
  };

  return (
    <GeneralStyle>
      <TableActions>
        <label>Guest | {nameEvent}</label>
        <RightSection>
          <ContentFilters>
            <GeneralFiltersContainer
              filtersViews={filtersViews}
              FilterEvents={FilterEvents}
              setDataFilter={setDataFilter}
              filtered={filtered}
              setFiltered={setFiltered}
            />
          </ContentFilters>
          <SearchComponent
            rSearch={rSearch}
            handleSearch={handleSearch}
            setSearchText={setSearchText}
          />
          <ContentDownloadFile
            className="mt-2"
            onClick={() => handleDownloadAttendees()}
          >
            <ExportExcelFile
              data={dataDownloadAttendees}
              nameFile={"downloaded-guests"}
              withIcon={true}
            ></ExportExcelFile>
            <TextDownloadFile style={{ paddingLeft: "5px" }}>
              Download
            </TextDownloadFile>
          </ContentDownloadFile>
        </RightSection>
      </TableActions>
      {fromPage === "/CoachEvents/" && (
        <div>
          <CoachEventThemeUpdate event={event} allThemes={allThemes} />
        </div>
      )}
      {!showCards && (
        <MaterialTable
          title=""
          columns={[
            {
              title: "Attendance",
              field: "attendanceCheck",
              sorting: false,
              type: "string",
              render: (rowData) => {
                return (
                  <>
                    <Checkbox
                      {...label}
                      defaultChecked={rowData.attendanceCheck}
                      checked={rowData.attendanceCheck}
                      sx={{
                        color: purple[400],
                        "&.Mui-checked": {
                          color: purple[400],
                        },
                      }}
                      onClick={() =>
                        handleCheckAttendance(rowData, rowData.attendanceCheck)
                      }
                    />
                  </>
                );
              },
            },
            {
              title: "First Name",
              field: "firstName",
              type: "string",
            },
            {
              title: "Last Name",
              field: "lastName",
              type: "string",
            },
            {
              title: "Email",
              field: "Email",
              type: "string",
            },
            {
              title: "Country",
              field: "country",
              type: "string",
              cellStyle: {
                padding: "5px 29px",
              },
              render: (rowData) => {
                return (
                  <ReactCountryFlag
                    svg
                    countryCode={rowData.country}
                    style={{
                      width: "1.5rem",
                      height: "1.5rem",
                      borderRadius: "8px",
                    }}
                  />
                );
              },
            },
            {
              title: "City",
              field: "city",
              type: "string",
            },
            {
              title: "Registration Date",
              field: "registrationDateFormatted",
              type: "string",
            },
            {
              title: "Status",
              field: "status",
              type: "string",
              render: (rowData) => {
                let titleStatus =
                  rowData.status === "Accept" ? "Accept" : "Decline";
                let bgStatus =
                  rowData.status === "Accept" ? themeConfig.status.successDark : themeConfig.status.errorPale;
                return (
                  <Tooltip
                    title={
                      rowData.status === "Unconfirmed" ? "Pending" : titleStatus
                    }
                  >
                    <div
                      className="point"
                      style={{
                        background: `${rowData.status === "Unconfirmed"
                          ? themeConfig.status.info
                          : bgStatus
                          }`,
                        height: "1em",
                        width: "1em",
                        borderRadius: "7px",
                      }}
                    ></div>
                  </Tooltip>
                );
              },
            },
            {
              title: "User Status",
              field: "isDeletedUser",
              sorting: false,
              type: "boolean",
              render: (rowData) => {
                return (
                  <>
                    {rowData.isDeletedUser ? (
                      <Tooltip title={"Deleted"}>
                        <PersonOffIcon
                          style={{ color: themeConfig.text.disabled }}
                        />
                      </Tooltip>
                    ) : (
                      <Tooltip title={"Active"}>
                        <PersonIcon style={{ color: themeConfig.primary.greenDark }} />
                      </Tooltip>
                    )}
                  </>
                );
              },
            },
            {
              title: "Delete",
              field: "internal_action",
              sorting: false,
              cellStyle: {
                padding: "0px 6px",
              },
              headerStyle: {
                padding: "0px",
              },
              render: (rowData) =>
                rowData && (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Tooltip title="Delete">
                      <IconButton
                        aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true"
                        className={classes.active}
                        onClick={(e) => setOpenDeleteModal(rowData)}
                      >
                        <DeleteTwoTone style={{ color: themeConfig.text.primary }} />
                      </IconButton>
                    </Tooltip>
                  </div>
                ),
            },
          ]}
          data={data}
          components={{
            Header: (props) => (
              <TableHead>
                <TableRow>
                  {props.columns.map((column, idx) => {
                    // return only the real columns
                    return column.title !== "Attendance" ? (
                      <TableCell key={idx}>{column.title}</TableCell>
                    ) : (
                      <TableCell
                        style={{
                          paddingLeft: "10px",
                        }}
                      >
                        <p style={{ margin: 0 }}>Attendance</p>
                        <Checkbox
                          sx={{
                            color: purple[400],
                            "&.Mui-checked": {
                              color: purple[400],
                            },
                          }}
                          defaultChecked={allAttendend}
                          onClick={handleCheckAllAttendance}
                        />
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
            ),
          }}
          options={{
            maxBodyHeight: 450,
            paging: false,
            search: false,
            headerStyle: {
              zIndex: 0,
              fontWeight: "bold",
            },
            cellStyle: {
              padding: "5px 10px",
            },
          }}
        ></MaterialTable>
      )}
      {showCards && (
        <ViewControlMenu
          identity={"private-guests"}
          title={"Testing send email notification"}
          showCards={showCards}
          setShowCards={setShowCards}
          list={data}
          isAgent={false}
          handleClickActions={handleClickActions}
          anchorSelected={anchorSelected}
          anchorEl={anchorEl}
          handleCloseActions={handleCloseActions}
          setAnchorEl={setAnchorEl}
          setAnchorSelected={setAnchorSelected}
          setOpenDeleteModal={setOpenDeleteModal}
        />
      )}
      <Row style={{ backgroundColor: themeConfig.neutral.white, marginTop: "1rem" }}>
        <Col md="4">
          <Convention>
            <div
              style={{
                background: themeConfig.status.errorPale,
                height: "1em",
                width: "1em",
                borderRadius: "7px",
              }}
            ></div>
            <p>Declined </p>
            <div
              style={{
                background: themeConfig.status.info,
                height: "1em",
                width: "1em",
                borderRadius: "7px",
              }}
            ></div>
            <p>Pending</p>
            <div
              style={{
                background: themeConfig.status.successDark,
                height: "1em",
                width: "1em",
                borderRadius: "7px",
              }}
            ></div>
            <p>Accepted</p>
          </Convention>
        </Col>
        <Col md="8" style={{ paddingRight: "0" }}>
          {allPages > 0 && rowsPerPage && rowsPerPageOptions && (
            <TablePagination
              component="div"
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
              count={allPages}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={rowsPerPageOptions}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Col>
      </Row>
      {showDeleteModal()}
    </GeneralStyle>
  );
};
export default AdminPrivateGuestsComponent;
